export const title = 'Conversão média';
import ConversionAttributionNote from '../../shared/partials/conversion-attribution-note.pt.mdx';

Taxa de conversão média entre todas as campanhas enviadas.

A taxa de conversão de uma campanha é `qtd_vendas_atribuidas / qtd_aberturas`.

Onde `qtd_vendas_atribuidas` é a quantidade de vendas atribuídas à campanha e `qtd_aberturas` é quantas pessoas abriram a notificação enviada pela campanha.

<ConversionAttributionNote />
